import React from 'react';
import './terms.css';

const TC = () => {
    return (
        <div className="Terms">
            <h1>Terms and Conditions for Africa Mining Summit Investment 2024 Registration</h1>
            <p><strong>Powered by Yep Group Mining</strong></p>

            <h2>1. Introduction</h2>
            <p>Welcome to the Africa Mining Summit Investment 2024 powered by Yep Group Mining. By registering for this event, you agree to comply with and be bound by the following terms and conditions. Please review these terms carefully.</p>

            <h2>2. Registration and Payment</h2>
            <ul>
                <li><strong>Eligibility:</strong> Participants must complete the registration form with accurate and truthful information.</li>
                <li><strong>Payment:</strong> All conference fees must be paid in full before the start of Africa Mining Summit Investment 2024. Registration is only confirmed upon receipt of full payment.</li>
                <li><strong>Cancellation and Refunds:</strong>
                    <ul>
                        <li>No refunds will be issued for cancellations made at any time.</li>
                        <li>All refund requests will be rejected, and payments are considered final upon confirmation of registration.</li>
                    </ul>
                </li>
            </ul>

            <h2>3. Substitution Policy</h2>
            <p>Substitutions of participants can be made up to 7 days before the summit without any additional charges. All substitution requests must be made in writing to <a href="mailto:mining@yepgroup.co.za">mining@yepgroup.co.za</a>.</p>

            <h2>4. Conference Program and Speakers</h2>
            <ul>
                <li>The event schedule is subject to change without prior notice. We reserve the right to make modifications to the schedule, speakers, or topics as necessary.</li>
                <li>In case of cancellation of the event due to unforeseen circumstances, a full refund of the registration fee will be provided. However, the organizers are not liable for any other expenses such as travel or accommodation costs.</li>
            </ul>

            <h2>5. Code of Conduct</h2>
            <ul>
                <li>All attendees are expected to behave professionally and respectfully toward others throughout the summit.</li>
                <li>Any form of harassment, discrimination, or inappropriate behavior will not be tolerated and may result in removal from the event without a refund.</li>
            </ul>

            <h2>6. Data Privacy</h2>
            <p>By registering for the summit, you consent to the collection, use, and sharing of your personal data in compliance with the Protection of Personal Information Act (POPIA). Your information may be used for summit-related communications, identification, and future event promotions.</p>

            <h2>7. Intellectual Property</h2>
            <p>All materials shared during the summit, including presentations, documents, and recordings, are the intellectual property of their respective owners and are protected by South African copyright laws. Unauthorized distribution, reproduction, or use of these materials without prior permission is prohibited.</p>

            <h2>8. Liability</h2>
            <p>The organizers of Africa Mining Summit Investment 2024 are not liable for any loss, injury, or damage to persons or property during the summit unless caused by gross negligence. Attendees are responsible for their own travel, accommodation, and any other personal expenses.</p>

            <h2>9. Force Majeure</h2>
            <p>The organizers are not liable for any failure or delay in fulfilling their obligations due to events beyond their control, such as natural disasters, war, strikes, or government regulations.</p>

            <h2>10. Amendments</h2>
            <p>We reserve the right to amend these terms and conditions at any time. Registered participants will be notified of any changes via email.</p>

            <h2>11. Governing Law</h2>
            <p>These terms and conditions shall be governed by and interpreted in accordance with the laws of the Republic of South Africa.</p>

            <h2>12. Contact Information</h2>
            <p>For any questions or concerns regarding these terms and conditions, please contact us at <a href="mailto:mining@yepgroup.co.za">mining@yepgroup.co.za</a>.</p>
        </div>
    );
}

export default TC;
